import { CustomBox, Heading } from "@/common/StyledComponents";
import { Button, Grid, IconButton, Modal, useTheme } from "@mui/material";
import { useState } from "react";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { request } from "@/Api";

export default function RefuteBillPopup({bill}) {  
    const [ open, setOpen ] = useState(false)
    const theme = useTheme()
    const handleRefute = () => {
        request.post(`accounting-bills/${bill.id}/refute-producer`, {
            reason: "Refuted by finance",
            message: `Bill ${bill.id} refuted by finance`
        })
        .then(()=>{
            setOpen(false)
        })
    }
    return (
        <>
            <IconButton onClick={()=>{setOpen(true)}}>
                <WarningAmberRoundedIcon />
            </IconButton>
            <Modal onClose={()=>{setOpen(false)}} open={open}>
                <CustomBox sx={{background: theme.palette.background.default, padding: 4}}>
                    <Heading>Refute Bill</Heading>
                    <p>{`Are you sure you want to refute the bill ${bill?.accounting_bill_number}?`}</p>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button variant="contained" color="secondary" onClick={()=>{setOpen(false)}}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={handleRefute}>
                                Refute
                            </Button>
                        </Grid>
                    </Grid>
                </CustomBox>
            </Modal>
        </>
    )
}